module.exports = __webpack_public_path__ + "assets/img/1.33d8ff38.jpg";